import { IconButton, Tooltip } from '@chakra-ui/react';
import { useState } from 'react';
import ActEdit from '../../../canopy-ui-components/components/Icons/ActEdit';
import * as ga from '../../../canopy-ui-components/google-analytics/index';
import { useCurrentColors } from '../../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';
import CreateOrEditMenuMappingModal from '../CreateOrEditMenuMappingModal';

export function EditMenuMappingAction(props: {
    userId?: number[];
    data?: any[];
    globalProps?: GlobalProps;
    refreshData?: (args?: any) => void;
}) {
    const { globalProps, data } = props;
    const currentColors = useCurrentColors();
    const [showModal, setShowModal] = useState(false);
    const { t } = globalProps || {};

    const handleClick = async () => {
        ga.event({
            action: `${window.location.pathname.replace(
                '//g/',
                ''
            )} > Clicked Edit Menu Mapping`,
            menu: props?.data?.[0]?.description,
        });
        setShowModal(true);
    };
    return (
        <>
            <Tooltip
                aria-label="edit"
                label={t('ui.mm.tooltip.edit-mapping')}
                placement="bottom-start"
                hasArrow
            >
                <IconButton
                    background="transparent"
                    cursor="pointer"
                    border="none"
                    width="20px !important"
                    minWidth="20px !important"
                    height="20px !important"
                    icon={<ActEdit />}
                    aria-label="delete"
                    data-test="delete"
                    backgroundColor="transparent"
                    color={currentColors.brand['300']}
                    variant="ghost"
                    _hover={{
                        backgroundColor: 'transparent',
                    }}
                    _focus={{
                        border: '0px',
                        backgroundColor: 'transparent',
                        outline: 'none',
                    }}
                    _active={{
                        border: '0px',
                    }}
                    isLoading={showModal}
                    onClick={handleClick}
                ></IconButton>
            </Tooltip>
            <CreateOrEditMenuMappingModal
                {...props}
                mappingData={data}
                setShowModal={setShowModal}
                showModal={showModal}
                edit={true}
            />
        </>
    );
}

export default EditMenuMappingAction;
